import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaChevronLeft, FaPlay } from 'react-icons/fa';

const IndividualMockTestStartPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { subject, testName, duration } = location.state || {};

  const handleContinue = () => {
    navigate('/individual-mock-test-instructions', {
      state: {
        subject: subject,
        testName: testName,
        duration: duration
      }
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-teal-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <button
            onClick={() => navigate('/individual-mock-tests')}
            className="flex items-center text-blue-600 hover:text-blue-800 transition-colors mb-6"
          >
            <FaChevronLeft className="mr-2" /> Back to Individual Tests
          </button>

          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-4">
              Ready to Start Your Test?
            </h1>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h2 className="text-xl font-bold text-blue-800 mb-2">{testName}</h2>
              <p className="text-gray-600 mb-2">Duration: {duration}</p>
              <p className="text-gray-600">
                This is a full-length mock test under real exam conditions.
              </p>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={handleContinue}
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-bold rounded-lg hover:opacity-90 transition-all duration-300 text-lg shadow-lg hover:shadow-xl flex items-center justify-center mx-auto space-x-3"
            >
              <FaPlay className="text-sm" />
              <span>Continue to Instructions</span>
            </button>
            <p className="text-gray-500 text-sm mt-4">
              Review the instructions before starting your test
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndividualMockTestStartPage;